export default "__VITE_ASSET__BNl_vbtB__"